import React from 'react';
import Link from 'next/link';
import type { WPublicGuestCollectionDetailView } from '@zola/svc-web-api-ts-client';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

// styles
import styles from './CompletionPage.module.less';

interface CompletionPageProps {
  guestName: string | undefined;
  weddingDetails: WPublicGuestCollectionDetailView;
}

const CompletionPage: React.FC<CompletionPageProps> = ({ weddingDetails, guestName }) => {
  const image = weddingDetails.image_link ? (
    <img className={styles.image} src={weddingDetails.image_link} alt="placeholder" />
  ) : (
    <video autoPlay loop playsInline muted className={styles.image}>
      <source
        src="https://zola-web-assets.s3.amazonaws.com/static-assets/videos/super-link/super-link-animation-rebrand.mp4"
        type="video/mp4"
      />
    </video>
  );
  const coupleNames = `${weddingDetails.owner_first_name} & ${weddingDetails.partner_first_name}`;

  const textConfig = {
    title: "Also 👋 we're Zola!",
    text: "We help engaged couples bring their weddings to life. If you're getting married, let's chat.",
    ctaText: 'Get to Know Us',
    href: '/',
  };

  return (
    <section
      className={styles.main}
      style={{
        backgroundImage: `url(${process.env.ASSET_PATH}/static-preauth/images/AddressCollection/mobileFormBackground.svg)`,
      }}
    >
      <div
        className={styles.photoSection}
        style={{
          backgroundImage: `url(${process.env.ASSET_PATH}/static-preauth/images/AddressCollection/polaroid.svg)`,
        }}
      >
        {image}
        <p className={styles.weddingDate}>
          {weddingDetails.wedding_date &&
            new Date(weddingDetails.wedding_date).toLocaleString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              timeZone: 'UTC',
            })}
        </p>
      </div>
      <div className={styles.infoSection}>
        <h1 className={styles.title}>
          You&apos;re All Set, <span className={styles.guestName}>{guestName}!</span>
        </h1>
        <p className={styles.dek}>{coupleNames} are doing a happy dance.</p>
        <div className={styles.actionSection}>
          <h4>{textConfig.title}</h4>
          <p>{textConfig.text}</p>
          <Link href={textConfig.href}>
            <ButtonV3 className={styles.cta} component="a" role="link">
              {textConfig.ctaText}
            </ButtonV3>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CompletionPage;
